export enum KeyCode {
  Tab = 9,
  Enter = 13,
  Up = 38,
  Down = 40,
  KeyD = 68,
  KeyH = 72,
  KeyK = 75,
  KeyN = 78,
}
